<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/transmission/9HAT/9HAT.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">9HAT longitudinally 9-speed AT transmission</div>
                <div class="detail-banner-desc transmission">

                    <div class="detail-desc">
                        <div>
                            Integrated high-performance P2 motor, Peak performance 130kW/495N·m;<br />
                        </div>
                        <div>
                            The vehicle can achieve multiple operating modes, including pure oil, pure electric, hybrid, and power generation;<br />
                        </div>
                        <div>
                            Motor and torque converter integrated design achieves outstanding power performance.
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="one-titile">
                    Core Configuration
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/transmission/9HAT/9HAT-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">850N·m</div>
                                    <div class="k">Torque capacity</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">9+R</div>
                                    <div class="k">Gear</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">720.8</div>
                                    <div class="k">Axial size(mm)</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">129kg</div>
                                    <div class="k">Weight(with oil)</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">8.843</div>
                                    <div class="k">Ratio range</div>
                                </div>
                                
                                <div class="spec-item">
                                    <div class="v">130kW/495N·m</div>
                                    <div class="k">P2 Motor peak performance</div>
                                </div>
                                <div class="spec-item spec-item-last">
                                    <div class="v">Electro-hydraulic control system</div>
                                    <div class="k">Actuation system</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
  title: '9HAT longitudinally 9-speed AT transmission - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/transmission/9HAT.html'

};

import { createApp } from 'vue';
import App from './9HAT.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./9HAT.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
